import React, { useState } from 'react';
import MainToolbar from '../MainToolbar';
import { TableContainer, Table, TableRow, TableCell, TableHead, TableBody, makeStyles, IconButton, Paper } from '@material-ui/core';
import t from '../common/localization';
import { useEffectAsync } from '../reactHelper';
import EditCollectionView from '../EditCollectionView';
import { formatBoolean } from '../common/formatter';
import EditIcon from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
import { green, blue, red, grey } from '@material-ui/core/colors';
import Avatar from "@material-ui/core/Avatar";
import SearchBar from "material-ui-search-bar";


const useStyles = makeStyles(theme => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
    backgroundColor: 'white',
  },
  rowAction: {
     backgroundColor: '#361DDB',
  },
  iconButtons: {
      marginLeft: 'auto',
      display: 'flex',
  },
   small: {
        width: theme.spacing(4),
        height: theme.spacing(4),
        backgroundColor:'#EFEFEF',
        margin: '2px'
      },
  tableRow: {
       "&$hover:hover": {
       backgroundColor: "#FFFFFF"
     }
   },
  tCell: {
      color: "white",
      backgroundColor: "#361DDB"
      },
  tContainer: {
      maxHeight: 688
      },
}));

const DeviceModelsView = ({ updateTimestamp, onMenuClick, handleOnEdit, handleOnRemove }) => {
  const classes = useStyles();
  const [successDialogShow, setSuccessDialogShow] = useState(false);

  const [items, setItems] = useState([]);
 const [searchList, setSearchList] = useState([]);

  useEffectAsync(async () => {
    const response = await fetch('/api/deviceModels');
    if (response.ok) {
      const res = await response.json()
      setItems(res);
      setSearchList(res);
    }
  }, [updateTimestamp]);

 const searchChange =(val)=>{

     const newItems = items.filter((current)=> {
       const {name, protocol, port, vendor} = current;
       let checkval= `${name||''}${protocol||''}${port||''}${vendor||''}`;
       checkval = checkval.toLowerCase();
       return checkval.includes(val && val.toLowerCase());
     });

     setSearchList(newItems);
   }

   const reset = ()=> {
     console.log('val');
   }
  const filterItems = searchList.sort((a,b) => new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime());

  return (
  <>
<SearchBar
      // value= {'search'}
      onChange={searchChange}
      onCancelSearch={reset}
      placeholder ="Search here..."
      className="searchBarInput"
      style={{ borderRadius:15, height:35, boxShadow: "2px 2px 2px 2px #dbddef", fontSize: 12, marginBottom:'10px', width:"300px"}}
      // onRequestSearch={() => doSomethingWith()}
    />
    <TableContainer className={classes.tContainer} component={Paper}>
    <Table stickyHeader aria-label="sticky table" className={classes.tableAction} size="small" >
      <TableHead>
        <TableRow className={classes.rowAction} >
          <TableCell className={classes.tCell}>{t('deviceModelNumber')}</TableCell>
          <TableCell className={classes.tCell}>{t('protocol')}</TableCell>
          <TableCell className={classes.tCell}>{t('port')}</TableCell>
          <TableCell className={classes.tCell}>{t('vendor')}</TableCell>
          <TableCell className={classes.tCell}>{t('commandSetTimezone')}</TableCell>
          <TableCell className={classes.tCell}>{t('apnCmd')}</TableCell>
          <TableCell className={classes.tCell}>{t('serverCmd')}</TableCell>
          <TableCell className={classes.tCell}>{t('commandEngineResume')}</TableCell>
          <TableCell className={classes.tCell}>{t('commandEngineStop')}</TableCell>
          <TableCell className={classes.tCell}>{t('extraCmd1')}</TableCell>
          <TableCell className={classes.tCell}>{t('extraCmd2')}</TableCell>
          <TableCell className={classes.tCell} />
        </TableRow>
      </TableHead>
      <TableBody>
        {filterItems.map((item) => (
          <TableRow
           hover
           key={item.id}
           className={classes.tableRow}>

            <TableCell>{<b>{item.name}</b>}</TableCell>
            <TableCell>{item.protocol}</TableCell>
            <TableCell>{item.port}</TableCell>
            <TableCell>{item.vendor}</TableCell>
            <TableCell>{item.attributes.setTimezone}</TableCell>
            <TableCell>{item.attributes.apnCmd}</TableCell>
            <TableCell>{item.attributes.serverCmd}</TableCell>
            <TableCell>{item.attributes.engineResume}</TableCell>
            <TableCell>{item.attributes.engineStop}</TableCell>
            <TableCell>{item.attributes.extraCmd1}</TableCell>
            <TableCell>{item.attributes.extraCmd2}</TableCell>
             <TableCell className={classes.columnAction} padding="none">
              <div className={classes.iconButtons}>
                                                                         <Avatar className={classes.small} >
                                                                         {<IconButton onClick={(event) => handleOnEdit(item.id)}>
                                                                          <EditIcon fontSize="small" style={{ color: blue[600] }}/>
                                                                         </IconButton>}
                                                                         </Avatar>
                                                                         <Avatar className={classes.small} >
                                                                         {<IconButton onClick={(event) => handleOnRemove(item.id)}>
                                                                          <ClearIcon fontSize="small" style={{ color: grey[450] }}/>
                                                                         </IconButton>}
                                                                         </Avatar>
                                                                         </div>
                        </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    </TableContainer>
    </>
  );
}

const DeviceModelsPage = () => {
  return (
    <>
      <MainToolbar />
      <EditCollectionView content={DeviceModelsView} editPath="/deviceModels" endpoint="deviceModels"
                     successDialogShow={false}
/>
    </>
  );
}

export default DeviceModelsPage;
